import { render, staticRenderFns } from "./SaleTypeNew.vue?vue&type=template&id=6f9af302"
import script from "./SaleTypeNew.vue?vue&type=script&lang=ts"
export * from "./SaleTypeNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f9af302')) {
      api.createRecord('6f9af302', component.options)
    } else {
      api.reload('6f9af302', component.options)
    }
    module.hot.accept("./SaleTypeNew.vue?vue&type=template&id=6f9af302", function () {
      api.rerender('6f9af302', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-sales/SaleTypeNew.vue"
export default component.exports